"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembershipsAPI = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const path_1 = require("../utils/path");
const utils_1 = require("../utils/utils");
class MembershipsAPI {
    constructor(http) {
        this.http = http;
    }
    inviteByEmail({ email, user_group, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.post({
                path: path_1.MEMBERSHIP_API_URLS.INVITE,
                data: { email, user_group },
            });
            const membershipDto = yield response.json();
            return (0, utils_1.convertToMembershipInterface)(membershipDto);
        });
    }
    leaveGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.post({
                path: path_1.MEMBERSHIP_API_URLS.MEMBERSHIPS,
                data: Object.assign(Object.assign({}, data), { status: bridge_schema_1.MembershipStatus.None }),
            });
            const membershipDto = yield response.json();
            return (0, utils_1.convertToMembershipInterface)(membershipDto);
        });
    }
    accept({ membershipId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: `${path_1.MEMBERSHIP_API_URLS.MEMBERSHIPS}${membershipId}/`,
                data: {
                    status: bridge_schema_1.MembershipStatus.Member,
                },
            });
            const membershipDto = yield response.json();
            return (0, utils_1.convertToMembershipInterface)(membershipDto);
        });
    }
    removeUserFromGroup(membershipId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: `${path_1.MEMBERSHIP_API_URLS.MEMBERSHIPS}${membershipId}/`,
                data: { status: bridge_schema_1.MembershipStatus.NotMember },
            });
            const membershipDto = yield response.json();
            return {
                member: (0, utils_1.convertToMembershipInterface)(membershipDto),
                groupId: membershipDto.group,
            };
        });
    }
    inviteUserToGroup({ group, to_user_id, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.post({
                path: path_1.MEMBERSHIP_API_URLS.MEMBERSHIPS,
                data: {
                    group,
                    to_user_id,
                    status: bridge_schema_1.MembershipStatus.Invited,
                },
            });
            const membershipDto = yield response.json();
            return (0, utils_1.convertToMembershipInterface)(membershipDto);
        });
    }
    decline({ membershipId, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: `${path_1.MEMBERSHIP_API_URLS.MEMBERSHIPS}${membershipId}/`,
                data: {
                    status: bridge_schema_1.MembershipStatus.NotMemberByUser,
                },
            });
            const membershipDto = yield response.json();
            return (0, utils_1.convertToMembershipInterface)(membershipDto);
        });
    }
    retractAdmin(membershipId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.patch({
                path: `${path_1.MEMBERSHIP_API_URLS.MEMBERSHIPS}${membershipId}/`,
                data: { admin: false },
            });
            const membershipDto = yield response.json();
            return {
                member: (0, utils_1.convertToMembershipInterface)(membershipDto),
                groupId: membershipDto.group,
            };
        });
    }
    grantAdmin({ group, to_user_id, }) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.post({
                path: path_1.MEMBERSHIP_API_URLS.MEMBERSHIPS,
                data: {
                    group,
                    to_user_id,
                    admin: true,
                },
            });
            const membershipDto = yield response.json();
            return {
                member: (0, utils_1.convertToMembershipInterface)(membershipDto),
                groupId: membershipDto.group,
            };
        });
    }
    getByGroup(groupId, limit = 25, offset = 0) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.http.get({
                path: `${path_1.MEMBERSHIP_API_URLS.GET_BY_GROUP}group=${groupId}&limit=${limit}&offset=${offset}/`,
            });
            const membershipDtoArray = yield response.json();
            return membershipDtoArray.map(utils_1.convertToMembershipInterface);
        });
    }
}
exports.MembershipsAPI = MembershipsAPI;
